import { forwardRef, useId } from 'react'
import { cn } from './cn'

export interface ToggleProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
	label?: React.ReactNode
	description?: React.ReactNode
	size?: 'xs' | 'sm' | 'md'
}

export const Toggle = forwardRef<HTMLInputElement, ToggleProps>(function Toggle(
	{ label, description, size = 'md', className, id, ...rest },
	ref,
) {
	const generatedId = useId()
	const toggleId = id ?? generatedId
	const toggle = (
		<input
			ref={ref}
			id={toggleId}
			type="checkbox"
			role="switch"
			className={cn(
				'toggle-refined',
				size === 'sm' && 'toggle-refined-sm',
				size === 'xs' && 'toggle-refined-xs',
				className,
			)}
			{...rest}
		/>
	)
	if (!label && !description) return toggle
	return (
		<label htmlFor={toggleId} className="flex items-center justify-between gap-3 cursor-pointer">
			<span className="flex-1">
				<span className="text-sm font-medium block">{label}</span>
				{description && (
					<span className="text-xs opacity-70 block mt-0.5">{description}</span>
				)}
			</span>
			{toggle}
		</label>
	)
})
